import cookie from "js-cookie";
import { RESERVED_KEYS, isClient } from "@adgm/libs";

const cookieUtil = {
  set: (name: string, value: string) => {
    cookie.set(name, value ?? "");
  },
  remove: (name: string) => {
    cookie.remove(name);
  },
  // 获取所有的cookie
  get: () => {
    return cookie.get();
  },
};

export { cookieUtil };

/**
 * 循环清除其它所有locastorage，除过RESERVED_KEYS信息
 */
export const clearLocalStorage = () => {
  // 清除所有sessionStorage
  sessionStorage.clear();
  if (isClient) {
    window.dispatchEvent(new Event("sessionStorageChanged"));
  }
  Object.keys(localStorage).forEach(key => {
    // 缓存数据统一约定key里加关键字符串 cache 关键字
    // 一定不要轻易修改这里,否则涉及到缓存的功能可能会出错
    if (!RESERVED_KEYS.includes(key) && !key.toLowerCase().includes("cache")) {
      localStorage.removeItem(key);
    }
  });
};

/**
 * 循环清除所有cookie
 */
export const clearCookies = () => {
  const allCookies = cookieUtil.get();
  Object.keys(allCookies).forEach(key => {
    cookieUtil.remove(key);
  });
};
